/* eslint-disable */
import React from 'react';

import './empty-list.css';

import Empty from '../../../../../../../../../components/icons/Empty';

type Props = {
  title?: string;
  message?: string;
};

export function EmptyList({ title, message }: Props) {
  return (
    <div className="empty-list">
      <Empty height={120} width={180} />
      <p className="empty-list-title">{title}</p>
      <p className="title">{message}</p>
    </div>
  );
}
